//解决项目在安卓低版本系统和IE上白屏问题
import "@babel/polyfill";
// import Es6Promise from "es6-promise";
// Es6Promise.polyfill();

//start
import Vue from "vue";
import "./plugins/element.js";

import tableRelayout from "./plugins/tableRelayout";
Vue.use(tableRelayout);

import App from "./App.vue";
import router from "./router";
import store from "./store";

// import Icon from "vue-svg-icon/Icon.vue";

import "./scss/reset.css";

import echarts from "echarts";
import axios from "axios";
import md5 from "js-md5";
import apiConfig from "./api.config";
import common from "./common";

//解决项目在安卓低版本系统和IE上白屏问题
import "@babel/polyfill";
import Es6Promise from "es6-promise";
Es6Promise.polyfill();

// 动画库
import lottie from "vue-lottie";
Vue.component("lottie", lottie);
// svg图标
// Vue.component("icon", Icon);
import SvgIcon from "vue-svgicon";

Vue.use(SvgIcon, {
  tagName: "svgicon",
});

// 自动滚动插件
import scroll from "vue-seamless-scroll";
Vue.use(scroll);

// 全局引用自定义组件
import self from "./components/self";
Vue.use(self);

//sentry config
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
if (window.config.enableSentry) {
  Sentry.init({
    Vue,
    dsn: window.config.dsnUrl,
    beforeSend(event) {
      if (event.message == "ResizeObserver loop limit exceeded") {
        return null;
      }
      return event;
    },
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", /^\//],
      }),
    ],
    tracesSampleRate: 1.0,
    logErrors: true,
  });
}

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$http = axios;
Vue.prototype.$md5 = md5;
Vue.prototype.$apiConfig = apiConfig;
Vue.prototype.$common = common;
Vue.prototype.$sentry = Sentry;

axios.defaults.timeout = window.config.requestTimeout;

axios.interceptors.request.use(
  (config) => {
    config.headers.common["Authorization"] = localStorage.getItem("token");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    const code = response.data.code;
    if (code == 502) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/login";
    } else {
      localStorage.setItem("token_timestamp", Date.now());
    }
    return response;
  },
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

import languePlugin from "./langue";

Vue.use(languePlugin, { locale: "zh" });
// Vue.component('baidumap-js', {
//     render(createElement) {
//         return createElement(
//             'script',
//             {
//                 attrs: {
//                     type: 'text/javascript',
//                     src: 'https://api.map.baidu.com/getscript?v=3.0&ak=' + window.config.baiduAK + '&services=&t=' + new Date().getTime(),
//                 },
//             },
//         );
//     },
// },
// )
//引入百度地图
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
// 	ak: window.config.baiduAK
// })

import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1, // 图片加载失败后的重试次数
  // loading: 'http://tc.qdscitech.net/images/2021/06/17/loading.gif', //加载中显示的图片
  listenEvents: [
    "scroll",
    "wheel",
    "mousewheel",
    "resize",
    "animationend",
    "transitionend",
    "touchmove",
  ],
});

new Vue({
  router,
  store,
  global,
  render: (h) => h(App),
}).$mount("#app");
